import { useEffect } from "react";

const useDrawScannedImagesOnCanvas = (images: ImageData[]) => {
  useEffect(() => {
    images.forEach((image, index) => {
      const workingCanvas = document.getElementById(
        `working-canvas-${index}`
      ) as HTMLCanvasElement;
      const workingCtx = workingCanvas.getContext("2d");
      workingCtx?.putImageData(image, 0, 0);
    });
  }, [images]);
};

export default useDrawScannedImagesOnCanvas;
